export function tanyapendeta(id,text,contact){
  //console.log(bool[0]);
  var box = "text=" + text+"&id="+id+"&contact_id="+contact;
//  console.log(box);
 var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      console.log(this.responseText);
      //imagine using the same container..it does really help
      // container = this.responseText;
  localStorage.setItem("container",  this.responseText);
    }
  };

  xhttp.open("POST", "./php/keyin03.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.withCredentials = true;
  xhttp.send(box);
}